import { Chip, Paper, styled } from "@mui/material";
import { useEffect, useState } from "react";
import { Field } from "react-final-form";
import TextFieldControlSimple from "../../../components/FormComponents/TextField.component";
export interface MultiFormValue {
  key: any;
  label: string;
}

const MultiTextInput = ({ disabled, formAPI, onChange, name, initial, placeholder }: any) => {
  const [isDirty, setDirty] = useState<boolean>(false);
  const [chipData, setChipData] = useState<readonly MultiFormValue[]>(initial || []);
  const [newData, setNewData] = useState<string>("");

  const handleDelete = (chipToDelete: MultiFormValue) => () => {
    setChipData((chips) => chips.filter((chip) => chip.key !== chipToDelete.key));
  };

  const handleChange = (event: any) => {
    setNewData(event.target.value);
  };

  const handleBlur = () => {
    if (newData !== "") {
      const key = (chipData.length + Math.random()).toString(36).slice(4);
      setChipData((chips) => [...chips, { key: key, label: newData }]);
      setNewData("");
    }
  };

  const handleSubmit = (event: KeyboardEvent) => {
    if (event.code === "Enter" || event.code === "Tab" || event.code === ",") {
      if (event.code === "Tab") {
        if (newData !== "") {
          event.preventDefault();
        }
      }
      handleBlur();
    }
  };

  const handleRefreshState = () => {
    if (formAPI) {
      const state = formAPI.getFieldState(name);
      if (state) {
        const isDirty =
          JSON.stringify(chipData.map((item: any) => item.label)) !==
          JSON.stringify(initial.map((item: any) => item.label));
        if (!isDirty) {
          formAPI.resetFieldState(name);
        }
        setDirty(isDirty);
      }
    }
  };

  useEffect(() => {
    const chipLabels = chipData.map((item: any) => item.label);
    const initialLabels = (initial || []).map((item: any) => item.label);
    if (JSON.stringify(chipLabels) !== JSON.stringify(initialLabels)) {
      setChipData(initial || []);
    }
  }, [initial]);

  useEffect(() => {
    onChange(name, chipData);
    handleRefreshState();
  }, [chipData]);

  useEffect(() => {
    handleRefreshState();
  }, [initial]);

  return (
    <Wrapper className={disabled ? "disabledWrap" : ""} sx={{ borderColor: isDirty ? "rgb(255 182 0 / 70%)" : "" }}>
      {chipData.map((data) => {
        return (
          <ListItem sx={{ margin: { xs: "0 18px 18px 0", sm: "0 24px 0 0", md: "0 24px 0 0" } }} key={data.key}>
            <Chip label={data.label} onDelete={handleDelete(data)} />
          </ListItem>
        );
      })}
      <ListItem>
        <Field name={name}>
          {(props) => (
            <Input
              {...props}
              disabled={disabled}
              placeholder={placeholder ? placeholder : `Add ${name}..`}
              input={{
                ...props.input,
                value: newData,
                onChange: (event) => handleChange(event),
                onBlur: () => handleBlur(),
                onKeyDown: (e: any) => handleSubmit(e),
              }}
            />
          )}
        </Field>
      </ListItem>
    </Wrapper>
  );
};

const ListItem = styled("li")`
  margin: 0 6px 6px 0;
  height: 32px;
  & .MuiOutlinedInput-root,
  & .MuiChip-root {
    border-radius: 10px;
  }
`;

const Wrapper = styled(Paper)`
  display: flex;
  justify-content: start;
  flex-wrap: wrap;
  list-style: none;
  padding: 10px 14px 4px 14px;
  margin: 0;
  min-height: 54px;
  background: none;
  border: var(--border);
  box-shadow: none;
  border-color: ${({ theme }) => theme.palette.border.dark};
  &.disabledWrap {
    border-color: #9a9a9a;
  }
`;

const Input = styled(TextFieldControlSimple)`
  & input {
    padding: 0 12px;
    width: 300px;
    @media (min-width: 992px) {
      width: 800px;
    }
    height: 32px;
  }

  & fieldset {
    border: none;
  }
`;

export default MultiTextInput;
